import axios from "axios";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Banknote, History, ArrowDownToLine } from "lucide-react";

const cookie = Cookies.get("jwt");
const token = `${cookie}`;

const Point_commission = () => {
  const [points, setPoints] = useState(0.0);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/user/getDataProfile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setPoints(res.data.point))
      .catch((err) => console.error(err));
  }, []);

  const menuItems = [
    {
      to: "/user/point/withdraw",
      icon: <ArrowDownToLine className="w-5 h-5 text-blue-600" />,
      iconBg: "bg-blue-50",
      label: "ถอนเงิน",
      desc: "โอนเงินออกสู่บัญชีธนาคาร",
    },
    {
      to: "/user/point/bank",
      icon: <Banknote className="w-5 h-5 text-emerald-600" />,
      iconBg: "bg-emerald-50",
      label: "เอกสารการรับเงิน",
      desc: "ช่องทางการรับเงินและยืนยันตัวตน",
    },
    {
      to: "/user/point/history",
      icon: <History className="w-5 h-5 text-gray-500" />,
      iconBg: "bg-gray-50",
      label: "ประวัติการทำรายการ",
      desc: "ตรวจสอบรายการถอนเงินทั้งหมด",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-lg mx-auto px-4 py-8 space-y-4">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="flex items-center gap-3"
        >
          <button
            onClick={() => window.location.replace("/profiles")}
            className="w-9 h-9 bg-white rounded-xl flex items-center justify-center border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors flex-shrink-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider">บัญชีของฉัน</p>
            <h1 className="text-lg font-bold text-gray-900">คอมมิชชั่น</h1>
          </div>
        </motion.div>

        {/* ── Balance card ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.05, ease: "easeOut" }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
        >
          <div className="px-6 py-5 bg-gradient-to-br from-emerald-50 to-white">
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">ยอดเงินสะสมปัจจุบัน</p>
            <div className="flex items-baseline gap-2">
              <span className="text-4xl font-bold text-emerald-600">{Number(points).toLocaleString()}</span>
              <span className="text-xl text-gray-400 font-medium">฿</span>
            </div>
          </div>
          <div className="px-6 py-3 border-t border-gray-100 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-emerald-400" />
            <p className="text-xs text-gray-400">ยอดเงินพร้อมถอนขั้นต่ำ 1,000 บาท</p>
          </div>
        </motion.div>

        {/* ── Menu ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.1, ease: "easeOut" }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
        >
          <div className="px-5 py-3.5 border-b border-gray-100">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">จัดการคอมมิชชั่น</p>
          </div>
          <div className="divide-y divide-gray-50">
            {menuItems.map((item, i) => (
              <Link key={i} to={item.to}>
                <div className="flex items-center gap-3.5 px-5 py-4 hover:bg-gray-50 active:bg-gray-50 transition-colors cursor-pointer">
                  <div className={`w-9 h-9 ${item.iconBg} rounded-xl flex items-center justify-center flex-shrink-0`}>
                    {item.icon}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-800">{item.label}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{item.desc}</p>
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-gray-300 flex-shrink-0" />
                </div>
              </Link>
            ))}
          </div>
        </motion.div>

        {/* ── Info note ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.15, ease: "easeOut" }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4"
        >
          <p className="text-xs text-gray-500 leading-relaxed">
            การจ่ายค่าคอมมิชชั่นจะเกิดขึ้นหลังจากบริษัทได้รับค่าคอมมิชชั่นจากลูกค้าแล้ว และจะถูกหักภาษี ณ ที่จ่ายตามอัตราที่กฎหมายกำหนด
          </p>
        </motion.div>

      </div>
    </div>
  );
};

export default Point_commission;
